<template>
  <div
    data-component-element-id="alignElementsMenu"
    class="align-elements-menu-wrapper flex justify-center gap-4">
    <el-button-group
      v-for="({ key, values}) in alignElementsModel"
      :key="'alignment-' + key"
      :data-component-element-id="'alignElementsButtonGroup-' + key"
      class="cstm-group-btn">
      <el-tooltip
        v-for="value in values"
        :key="'alignment-' + key + '-' + value"
        :content="$t('template.' + value)"
        :popper-class="'custom-tooltip-popper'"
        :visible-arrow="false"
        effect="light"
        class="item"
        placement="bottom">
        <el-button
          :class="value"
          :data-component-element-id="'alignElementsButton-' + value"
          @click="handleAlignElementChange(value, key)">
        </el-button>
      </el-tooltip>
    </el-button-group>
  </div>
</template>

<script src="./align-elements-menu.js"></script>
<style lang="scss" src="./align-elements-menu.scss"></style>
